<template>
  <Panel :isLoading="isLoading">
    <h2 slot="title">
      PPE Compliance <span :class="`indicator ${avgCompliance}`"></span>

      <div style="display: flex; margin-left:auto;align-items:center;gap: 0.5rem">
        7 Days
        <el-switch v-model="use24Hrs" on-color="#333" off-color="#333" on-text="" off-text=""></el-switch>
        24 Hrs
      </div>
    </h2>
    <el-table :data="tableData">
      <el-table-column label="Moment" prop="moment"></el-table-column>
      <el-table-column label="Compliance" prop="compliance">
        <template scope="scope">
          <div v-if="scope.row.total === 0">
            ---
          </div>
          <div v-else>
            {{ scope.row.percent }}%
            <span class="complianceBreakdown">({{ scope.row.yes + scope.row.incomplete }}/{{ scope.row.total }})</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Panel>
</template>

<script>
import moment from "moment";
import Panel from "./Panel.vue";

export default {
  name: "PPECompliance",
  props: ["filters"],
  watch: {
    filters() {
      this.getSummary();
    },
    use24Hrs() {
      this.getSummary();
    }
  },
  components: {
    Panel
  },
  data() {
    return {
      avgCompliance: 0,
      isLoading: true,
      tableData: [],
      use24Hrs: true
    };
  },
  methods: {
    async getSummary() {
      this.isLoading = true;
      const { data } = await this.$http.get(`${window.CONFIG.ppe_api}/config/ops`).then(response => response.body);
      const moments = data.ops.sections.map(s => s.name);
      const filters = {
        filters: {
          recordedLocalDatetimeStart: moment()
            .subtract(7, "days")
            .format(),
          recordedLocalDatetimeEnd: moment().format(),
          includeDeleted: false
        },
        groupBy: ["sectionName", "week"],
        hhOutcomeCriteria: this.$configStore.hhOutcomeCriteria()
      };
      filters.filters.facilityIds = this.filters.facIds;

      if (this.filters.unitIds.length) {
        filters.filters.unitIds = this.filters.unitIds;
      }

      if (this.use24Hrs) {
        filters.filters.recordedLocalDatetimeStart = moment()
          .subtract(24, "hours")
          .format();
      }
      const response = await this.$http
        .post(`${window.CONFIG.ppe_api}/audit/summary`, filters)
        .then(resp => resp.json())
        .catch(() => {
          return [];
        });

      const defaults = {
        incomplete: 0,
        no: 0,
        yes: 0,
        percent: 0,
        total: 0
      };

      const mappedData = new Map(moments.map(m => [m, { moment: m, ...defaults }]));

      response.incomplete.forEach(r => {
        const record = mappedData.get(r.sectionName);
        record.incomplete += r.count;
        record.total += r.count;
        mappedData.set(r.sectionName, record);
      });
      response.yes.forEach(r => {
        const record = mappedData.get(r.sectionName);
        record.yes += r.count;
        record.total += r.count;
        mappedData.set(r.sectionName, record);
      });
      response.no.forEach(r => {
        const record = mappedData.get(r.sectionName);
        record.no += r.count;
        record.total += r.count;
        mappedData.set(r.sectionName, record);
      });
      this.tableData = [...mappedData.values()].map(r => {
        return {
          ...r,
          percent: Math.round(((r.yes + r.incomplete) / r.total) * 1000) / 10
        };
      });
      const avg = this.tableData.reduce((acc, val) => acc + val.yes, 0) / this.tableData.reduce((acc, val) => acc + val.total, 0);
      if (Number.isNaN(avg) || avg < 0.5) {
        this.avgCompliance = "red";
      } else if (avg >= 0.8) {
        this.avgCompliance = "green";
      } else {
        this.avgCompliance = "yellow";
      }
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.complianceBreakdown {
  color: grey;
}
.indicator {
  display: inline-block;
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;
}
.yellow {
  background-color: #ffdf00;
  border: 1px solid #cdb300;
}
.green {
  background-color: #04e300;
  border: 1px solid #288b00;
}
.red {
  background-color: #ff0000;
  border: 1px solid #cd0000;
}
</style>
